import { createBrowserRouter } from 'react-router-dom'
import { RequireAuth } from '@/auth/RequireAuth'
import { AppShell } from '@/components/AppShell'
import { BudgetCodeDetail } from '@/features/budgetCodes/BudgetCodeDetail'
import { BudgetCodesScreen } from '@/features/budgetCodes/BudgetCodesScreen'
import { DashboardScreen } from '@/features/dashboard/DashboardScreen'
import { CsiuImportScreen } from '@/features/csiu/CsiuImportScreen'
import { ExternalChargesScreen } from '@/features/external/ExternalChargesScreen'
import { ReceiptsScreen } from '@/features/receipts/ReceiptsScreen'
import { ReconciliationScreen } from '@/features/reconciliation/ReconciliationScreen'
import { SettingsScreen } from '@/features/settings/SettingsScreen'
import { SetupScreen } from '@/features/setup/SetupScreen'
import { TransactionsScreen } from '@/features/transactions/TransactionsScreen'
import { NotFoundScreen } from './placeholders'

/**
 * Routes. Code detail is reachable by ID so it can be bookmarked and linked
 * from a threshold-alert email (§8.2a); that screen lands in Step 7.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardScreen /> },
      { path: 'setup', element: <SetupScreen /> },
      { path: 'codes', element: <BudgetCodesScreen /> },
      { path: 'codes/:codeId', element: <BudgetCodeDetail /> },
      { path: 'receipts', element: <ReceiptsScreen /> },
      { path: 'transactions', element: <TransactionsScreen /> },
      { path: 'external', element: <ExternalChargesScreen /> },
      { path: 'import', element: <CsiuImportScreen /> },
      { path: 'reconcile', element: <ReconciliationScreen /> },
      { path: 'settings', element: <SettingsScreen /> },
      { path: '*', element: <NotFoundScreen /> },
    ],
  },
])
